import { Box, Typography } from "@mui/material";
import { FileUpload } from "@outpave/ds";
import { toFileList } from "utils/receipts/receiptUpload";
import { RECEIPT_FILE_ACCEPT } from "utils/receipts/receiptFileTypes";
import { useSupportedReceiptFiles } from "hooks/useSupportedReceiptFiles";
import { useTranslation } from "react-i18next";

interface FileUploadPageProps {
  onFilesAdded: (files: FileList) => Promise<void>;
}

const FileUploadPage: React.FC<FileUploadPageProps> = ({ onFilesAdded }) => {
  const { t } = useTranslation();
  const keepSupported = useSupportedReceiptFiles();

  // `accept` only filters the click picker, so a dragged file arrives whatever its type.
  const handlePicked = (picked: File[]) => {
    const supported = keepSupported(picked);
    if (supported.length === 0) return;
    onFilesAdded(toFileList(supported));
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "var(--space-4)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "var(--space-2)",
        }}
      >
        <Typography variant="h5" component="span">
          {t("File Upload")}
        </Typography>
        <Typography variant="body2" component="span">
          {t("ReceiptUploadDescription")}
        </Typography>
      </Box>
      <FileUpload
        variant="dropzone"
        multiple
        height={224}
        accept={RECEIPT_FILE_ACCEPT}
        onFiles={handlePicked}
        hint={t("JPG, PDF, PNG, WEBP  • Max 10MB • Up to 50 receipts")}
      />
    </Box>
  );
};

export default FileUploadPage;
